__turbopack_context__.v({
  "container": "BlockEdd-module__75guZW__container",
});
